<script async setup lang="ts">
import type { IAccoItem } from '@/composables/interfaces/apiInterfaces'
import AccoItemRating from './AccoItemRating.vue'

const props = defineProps<{
  item: IAccoItem[] | undefined
}>()
</script>

<template>
  <div class="embla__slide relative w-full hover:text-inherit" v-for="acco in props.item">
    <div class="pui-acco-card flex h-24 flex-row overflow-hidden !rounded border border-[var(--p-inputtext-border-color)] md:h-32">
      <div class="relative w-2/5">
        <div class="h-full overflow-hidden">
          <img class="aspect-video h-full w-full object-cover" :alt="acco.companyName" :src="acco.img" />
        </div>
      </div>
      <div class="relative w-3/5 items-center gap-1 px-2 py-1 leading-5 md:p-2">
        <AccoItemRating :is-superior="acco.isSuperior" :rating="acco.rating" :symbol-class="acco.symbolClass" />
        <div class="line-clamp-3 text-xs font-bold">
          {{ acco.companyName }}
        </div>
        <small class="mt-1 line-clamp-2 font-normal max-md:hidden">
          {{ acco.location }}
        </small>
      </div>
    </div>
  </div>
</template>

<style>
.acco-item-mini-carousel {
  .embla__slide {
    --slide-size: 30%;

    @media (max-width: 767px) {
      --slide-size: 80%;
    }

    flex: 0 0 var(--slide-size);
    min-width: 0;
  }

  .embla__button:disabled {
    display: none;
  }
}
</style>
